import { render } from "./kiosk-user-model.vue?vue&type=template&id=cb6a654a"
import script from "./kiosk-user-model.vue?vue&type=script&lang=js"
export * from "./kiosk-user-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__